import React from 'react';
import { SubHeading } from '../../components';
import { images } from '../../constants';

const FindUs = () => (
  <div className='app__bg app__wrapper section__padding' id='contact'>
    <div className='app__wrapper_info'>
    <SubHeading title="contact"/>
    <h1 className='headtext__cormorant' style={{marginBottom:"3rem"}}>Find Us</h1>

    <div className='app__wrapper-content'>
      <p className='p__opensans'>Akunola Aina Street, Mende, Lagos State, Nigeria.</p>
      <p className='p__cormorant' style={{color:"#dcca87", margin:"2rem 0"}}> Mobile Phone Numbers </p>
      <p className='p__cormorant' style={{color:"#dcca87", margin:"2rem 0"}}>+2347043667143, +2347063116133</p>
      <p className='p__opensans'>Email: Juadebgabriel@gmail.com</p>
    </div>
    <button className='custom__button' style={{marginTop:"2rem"}}>Contact Me</button>
    </div>
    <div className='app__wrapper_img'>
      <img src={images.findus} alt="findus"/>
    </div>
  </div>
);

export default FindUs;
